import { Modal } from "newui/components/ui/Modal";

export interface ZeroRowModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const ZeroRowModal: React.FC<ZeroRowModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Zero Row Values"
			iconType="error"
			modalType="standard"
			closeOnEsc
			closeOnOverlayClick
			size="sm"
			primaryButton={{
				text: "Zero All",
				onClick: onConfirm,
			}}
			secondaryButton={{
				text: "Cancel",
				onClick: onClose,
			}}
		>
			<div className="text-center font-roboto text-sm text-tertiary-600">
				<p className="mb-2">
					This row has existing values. Are you sure you want to set all numeric values to zero?
				</p>
			</div>
		</Modal>
	);
};

export { ZeroRowModal };
